import { ColorResolverStore } from './schema/ColorResolverStore';
import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';

const defaultStore: ColorResolverStore = {
    assignedCalendarColors: new ObservableMap(),
};

export const getStore = createStore('calendarColorResolverStore', defaultStore);
